import React from 'react'
import ProductionPlan from '../features/productionPlan/index'

export default function ProductionPlanPage() {
  return (
    
    <ProductionPlan />
  )

}
